// extracted by mini-css-extract-plugin
export default {"wrapper":"FilteredIcon_wrapper__1nQIF"};